var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-888 -336)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 12,
    transform: "translate(891 345)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 18,
    transform: "translate(888 336)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusWhiteIcon);
export default __webpack_public_path__ + "static/media/minus-white-icon.d479f5c1cf88b902b79031aa8fb7f192.svg";
export { ForwardRef as ReactComponent };